module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-selling orange"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "module-goods"
  }, [_c('ul', {
    staticClass: "clearfix",
    attrs: {
      "id": "hmggDiv"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      key: item.goodsId
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.designImage
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "pri"
    }, [_vm._v("¥   " + _vm._s(item.price))])])], 1)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mod-selling-title"
  }, [_c('span', [_vm._v("还没逛够")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61257f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/not-enough.vue
// module id = 1617
// module chunks = 1